module.exports = __webpack_public_path__ + "static/scale-model-of-toledo-firefighters-museum-in-toledo-ohio-f69eebd4e2fcc98115f071de379c6098.png";